import { render, staticRenderFns } from "./stuclazz-record-list.vue?vue&type=template&id=4fdda554&"
import script from "./stuclazz-record-list.vue?vue&type=script&lang=js&"
export * from "./stuclazz-record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports